import Base from '@studiometa/js-toolkit';
import Vue from 'vue';
import VueMobileSearch from './MobileSearch';
import { isDev } from '../../config';

/**
 * Search Autocomplete
 */
export default class MobileSearch extends Base {
  /**
   * Component configuration
   */
  get config() {
    return {
      name: 'MobileSearch',
      log: isDev(),
    };
  }

  /**
   * Mounted hook
   */
  mounted() {
    /**
     * Pass all data-options as props
     * @see block--em-main-search-autocomplete-mobile-block.html.twig
     */
    const props = {
      ...this.$options,
    };

    this.vue = new Vue({
      el: this.$refs.vue,
      data: () => ({
        isOpen: false,
      }),
      render(h) {
        return this.isOpen
          ? h(VueMobileSearch, {
              props,
            })
          : '';
      },
    });

    this.vue.$on('close', this.close);
    window.addEventListener('scroll', this.close);
  }

  /**
   * Btn Click Handle
   */
  onBtnClick() {
    this.open();
  }

  /**
   * Open
   */
  open() {
    this.vue.isOpen = true;
    window.document.body.style.overflowY = 'hidden';
  }

  /**
   * Close
   */
  close() {
    this.vue.isOpen = false;
    window.document.body.style.overflowY = '';
  }

  /**
   * Destroy hook
   */
  destroyed() {
    this.close();
    this.vue.$destroy(true);
    window.removeEventListener('scroll', this.close);
  }
}
